module.exports = __webpack_public_path__ + "static/img/bg-fr.eda76887.webp";